
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 23 17","fill":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.375 7.125a2.221 2.221 0 01-2.25-2.25c0-1.23.984-2.25 2.25-2.25 1.23 0 2.25 1.02 2.25 2.25 0 1.266-1.02 2.25-2.25 2.25zm15.75 0a2.221 2.221 0 01-2.25-2.25c0-1.23.984-2.25 2.25-2.25 1.23 0 2.25 1.02 2.25 2.25 0 1.266-1.02 2.25-2.25 2.25zM20.25 8.25c1.23 0 2.25 1.02 2.25 2.25v1.125c0 .633-.527 1.125-1.125 1.125h-2.32a5.183 5.183 0 00-2.672-3.832c.422-.387.984-.668 1.617-.668h2.25zm-9 0a3.931 3.931 0 01-3.938-3.938C7.313 2.168 9.07.376 11.25.376c2.145 0 3.938 1.793 3.938 3.938 0 2.18-1.793 3.937-3.938 3.937zm2.672 1.125A4.081 4.081 0 0118 13.453v.985c0 .949-.773 1.687-1.688 1.687H6.188a1.666 1.666 0 01-1.687-1.688v-.984c0-2.25 1.793-4.078 4.043-4.078h.281a5.592 5.592 0 002.426.563c.844 0 1.652-.211 2.39-.563h.282zm-7.84-.457A5.183 5.183 0 003.41 12.75H1.125A1.11 1.11 0 010 11.625V10.5c0-1.23.984-2.25 2.25-2.25H4.5c.598 0 1.16.281 1.582.668z"}})])
          )
        }
      }
    